import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { ToastContainer, toast } from 'react-toastify';
import withAuth from '../components/authHOC';
import { Card, Col } from 'react-bootstrap';
import { Button, DatePicker, DatePickerProps, Form, Input, Select, SelectProps, Space, Upload } from 'antd';
import { IClient, IGuarantor, IIdType, ILoan, ILoanpreviewData, IMetaDataGlobal, ISecurityType} from '../factory/interfaces';
import { AUTH_URL } from '../constants';
import axios from 'axios';
import moment from 'moment';
import { SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { MdOutlineCalculate } from "react-icons/md"
import { IoPrint } from "react-icons/io5"
import { LuSave } from "react-icons/lu"
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { notify_error } from '../components/Toaster'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getMetaData } from '../actions/metaActions';


export  const notify = (message: string, style: any) => toast.error(message, {
        style
        })
    //Toaster
export    const toastStyle: any =  {
        background: '#ffffff',
        color: '#0a0a0a',
        fontSize: "13px",
        padding: '2px',
        position: 'bottom-center',
        fontStyle: 'bold'
      }

export const notify_success = (message: string, style: any) => toast.success(message, {
        style
        })

export interface loginCredentials{
        email: string,
        password: string
    }

const NewLoanPage = () => {

  const [loan, setLoan]= useState<ILoan>()
  const [securityTypes, setSecurityTypes]= useState<ISecurityType[]>()
  const [idTypes, setIdTypes]= useState<IIdType[]>()
  const [form] = Form.useForm()
  const [submitting, setSubmitting] = useState(false)
  const [client, setClient]= useState<IClient>()
  const [marchedClient, setMarchedClient]= useState<IClient>()
  const [clients, setClients] = useState<SelectProps['options']>([])
  const [current_loan, setCurrentLoan]= useState<ILoan>()
  const [searchIdType, setSearchIdType] = useState<string | undefined>()
  const [searchId, setSearchId] = useState<string | undefined>()
  const [searching, setSearching]= useState(false)
  const [calculatingLoan, setCalculatingLoan] = useState(false)
  const [guarantors, setGuarantors]= useState<IGuarantor[]>([
    {name: '' , phone: '', address: ''},

    ])
  const [paymentPeriods, setPaymentPeriods] = useState<IMetaDataGlobal[]>()
  const [installmentPeriods, setInstallmentPeriods] = useState<IMetaDataGlobal[]>()
  const [loanPreviewData, setLoanPreviewData] = useState<ILoanpreviewData>()
  const [loadingPreviewData, setLoadingPreviewData] = useState(false)
  const [fileList, setFileList] = useState<any[]>([]);


  const componentRef = useRef(null);

  const handleGuarantorChange = (index: number, field: keyof IGuarantor, value: string) => {
  const newGuarantors = [...guarantors];

  newGuarantors[index][field] = value;
  setGuarantors(newGuarantors);
}

 const metadata = useSelector((state: any) => state.metadata)

  useEffect(() => {
    if (metadata?.data?.success) {
      setIdTypes(metadata.data.meta_data.id_types)
      setPaymentPeriods(metadata.data.meta_data.payment_periods)
      setInstallmentPeriods(metadata.data.meta_data.installment_periods)
      setSecurityTypes(metadata.data.meta_data.security_types)

    }
  }, [metadata])

  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(getMetaData() as any)
  }, [])


  //Submit

  const submit = async ()=>{
    setSubmitting(true)
    if(loan){
      loan.guarantors = guarantors
    }
    if(client && loan){
      loan.client = client._id
    }
    if (fileList.length > 0 && loan) {
      loan.file = fileList[0].originFileObj;
    }
    const response  = await axios.post(`${AUTH_URL}/finances/loans`, {...loan, client: client}, {withCredentials: true, headers: {
        'Content-Type': 'multipart/form-data',
      }})

    setSubmitting(false)

    if(response.data.success){
      notify_success(response.data.message, toastStyle)
      form.resetFields()
    }else{
      notify(`${response.data.message}`, toastStyle)
    }
  }
  const calculateLoan = async()=>{
    setLoadingPreviewData(true)
    setLoanPreviewData(undefined)
    setCalculatingLoan(true)
    const response = await axios.post(`${AUTH_URL}/finances/loans/calculate`, {payment_period: loan?.payment_period, amount: loan?.amount, installment_period: loan?.installment_period}, {withCredentials: true})
    setLoadingPreviewData(false)
    setCalculatingLoan(false)

    if(response.data.success){
  
      form.setFieldsValue({ total_amount_to_pay: response.data.loan.total_amount_to_pay })
      form.setFieldsValue({ interest_rate: response.data.loan.interest_rate })
      form.setFieldsValue({ min_installment_amount: response.data.loan.min_installment_amount })

      setLoanPreviewData(response.data.loan)
    }else{
      notify(`${response.data.message}`, toastStyle)
    }
  }



const searchClients = (value: string, callback: Function) => {
        axios.post(`${AUTH_URL}/clients/search`, {name: value}, {withCredentials: true})
            .then((response) => {
            const data = response.data.clients.map((client: IClient) => ({
                value: client._id,
                text: `${client.surname} ${client.given_name} (${client.phone}) (${client.id_number})`,
            }))
            callback(data);
            })
            .catch((error) => {
            notify(`${error.message}`, toastStyle)
            callback([])
            })
        }
  
const handleSearchClient = (newValue: string) => {
    searchClients(newValue, setClients)
  }



const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});


  return (
    <Container ref={componentRef} fluid id='users-container'>
        <Row className=' justify-content-center py-0 g-0'>
    <ToastContainer position="top-center" className='text-capitalize'/>
        </Row>
        <Row>
        <Col>
         <Card className='p-2 rounded-0'>
                <Form
                className='p-3'
                  layout="vertical"
                  form={form}
                  name="control-hooks"
                  onFinish={submit}

                    >
                    <Row className='p-3  border' style={{background: '#8888881d'}}>
                    <h5>Client details</h5>

                    <Row className='align-items-center'>
                    <Col lg={12} md={12}>
                        <Form.Item
                        label="Search client"
                        name="client"
                        rules={[{ required: true, message: "Client is required" }]}
                        >
                        <Select
                          showSearch
                          placeholder="Enter client's surname, given name or phone number to search"
                          defaultActiveFirstOption={false}
                          suffixIcon={null}
                          filterOption={false}
                          onSearch={handleSearchClient}
                          notFoundContent={null}
                          options={(clients || []).map((client) => ({
                            value: client.value,
                            label: client.text,
                          }))}
                          allowClear
                          onChange={setClient}
                        />
                        </Form.Item>
                      </Col>
                    </Row>
                   
                    </Row>
                    <Row className='p-3 my-3 border' style={{background: '#8888881d'}}>
                    <h5>Loan details</h5>
                    <Row>
                     <Col>
                    <Form.Item
                      label="Loan Category"
                      name="category"
                      rules={[{ required: true, message: "Loan category is required" }]}
                    >
                      <Select
                        allowClear
                        placeholder="Select loan category"
                        style={{ width: '100%' }}
                        options={[
                          { value: 'NEW', label: 'NEW' },
                          { value: 'OLD', label: 'OLD' },
                        ]}
                        onChange={(value) =>{
                            setLoan((prevUserData: any) => ({
                                ...prevUserData,
                                category: value,
                            }))
                                setLoanPreviewData(undefined)
                            }
                         }
                      />
                    </Form.Item>
                    </Col>
                    <Col>
                    <Form.Item
                      label="Loan amount"
                      name="amount"
                      rules={[{ required: true, message: "Amount lend is required" }]}
                    >
                      <Input
                        onChange={(e) =>{
                                setLoan((prevUserData: any) => ({
                                    ...prevUserData,
                                    amount: e.target.value,
                                }))
                                setLoanPreviewData(undefined)
                                }
                            }  
                        />
                    </Form.Item>
                    </Col>
                    <Col>
                    <Form.Item
                      label="Payment period"
                      name="payment_period"
                      rules={[{ required: true, message: "Payment period is required" }]}
                    >
                      <Select
                        allowClear
                        placeholder="Select payment period"
                        style={{ width: '100%' }}
                        options={paymentPeriods?.map((period) => ({
                          value: period._id,
                          label: period.name,
                        }))}
                        onChange={(value) =>{
                            setLoan((prevUserData: any) => ({
                                ...prevUserData,
                                payment_period: value,
                            }))
                                setLoanPreviewData(undefined)
                            }
                         }
                      />
                    </Form.Item>
                    </Col>
                    <Col>
                    <Form.Item
                      label="Installment period"
                      rules={[{ required: true, message: "Installment period is required!" }]}
                      name="installment_period"
                    >
                      <Select
                        allowClear
                        placeholder="select installment period"
                        style={{ width: '100%' }}
                        options={installmentPeriods?.map((type) => ({
                          value: type._id,
                          label: type.name,
                        }))}
                        onChange={(value) =>{
                            setLoan((prevUserData: any) => ({
                                ...prevUserData,
                                installment_period: value,
                            }))
                              setLoanPreviewData(undefined)
                            }

                         }
                      />
                    </Form.Item>
                    </Col>
                      <Col>
                    
                      <Form.Item
                      label="Security type"
                      rules={[{ required: true, message: "Security type is required!" }]}
                      name="security_type"
                    >
                      <Select
                        allowClear
                        placeholder="Select Security type"
                        style={{ width: '100%' }}
                        options={securityTypes?.map((type) => ({
                          value: type._id,
                          label: type.name,
                        }))}
                        onChange={(value) =>
                            setLoan((prevUserData: any) => ({
                                ...prevUserData,
                                security_type: value,
                            }))
                         }
                      />
                    </Form.Item>
                    </Col>
                    </Row>
                    <Col>
                     <Form.Item
                      label="Start date"
                      name="loan_start_date"
                      rules={[{ required: true, message: "Loan start date is required" }]}
                    >
                      <DatePicker 
                      style={{width: '100%'}} 
                      onChange={(date, dateString) =>
                                setLoan((prevUserData: any) => ({
                                    ...prevUserData,
                                    loan_start_date: dateString,
                                }))
                            }  
                      className='rounded-0'
                      />
                 
                    </Form.Item>
                    </Col>
                    <Col>
                   
                    <Form.Item
                      label="End date"
                      name="loan_end_date"
                      rules={[{ required: true, message: "Loan end date is required" }]}
                    >
                      <DatePicker 
                      className='rounded-0' 
                      style={{width: '100%'}} 
                      onChange={(date, dateString) =>
                                setLoan((prevUserData: any) => ({
                                    ...prevUserData,
                                    loan_end_date: dateString,
                                }))
                            }  
                      />
                    </Form.Item>
                    </Col>
                  
                      <Col>
                    
                      <Form.Item
                      label="Security"
                      rules={[{ required: true, message: "Security is required!" }]}
                      name="security"
                    >
                      <Input
                        onChange={(e) =>
                          setLoan((prevUserData: any) => ({
                            ...prevUserData,
                            security: e.target.value
                          }))
                        }
                      />
                    </Form.Item>
                    
                     
                    </Col>
                    <Col>
                    
                      <Form.Item
                      label='Documents'
                      name='documents'
                      >
                      <Upload
                          name='file'
                          style={{width: '100%'}}
                          fileList={fileList}
                          onChange={(info: any) => {

                            const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

                            if(!(info.file.type === 'application/pdf')){
                              notify('You can only upload PDF files!', toastStyle)

                            }
                            else if((info.file.size >= MAX_FILE_SIZE)){
                              notify_error('File must be smaller than 2MB!', toastStyle)
                            }else{
                            setFileList(info.fileList)
                            }
                            
                          }}
                      
                      >
                      {fileList.length < 2 &&
                        <Button style={{width: '100%'}} className='rounded-0' icon={<UploadOutlined />}>Upload security files</Button>
                        }
                      </Upload>

                      </Form.Item>
                    
                     
                    </Col>
                    <Col>
                    {
                      !loanPreviewData &&
                      <Form.Item
                     name='payment_preview_button'
                     label=' '
                    >
                    <Button loading={calculatingLoan} type='primary' onClick={calculateLoan} className='rounded-0 m-0 text-uppercase'>
                    <MdOutlineCalculate style={{marginRight: '5px'}} />
                    {
                      calculatingLoan
                      ?
                      'Calculating ...'
                      :
                      'Calculate Payments'

                    }
                    
                    </Button>
                    
                    </Form.Item>}
                    
                    </Col>
                    
                    
                    </Row>
                    {
                      (loanPreviewData && !loadingPreviewData) ?
                      
                      <Row className='p-3 my-3 border' style={{background: '#8888881d'}}>
                      <h5>Payment details</h5>
                      <Col>
                        <Form.Item
                            label="Total amount to pay"
                            name='total_amount_to_pay'
                            initialValue={loanPreviewData.total_amount_to_pay}
                          >
                            <Input
                            readOnly
                            />
                          </Form.Item>
                      
                      </Col>
                      <Col>
                        <Form.Item
                            label="Interest rate"
                            name='interest_rate'
                            initialValue={loanPreviewData.interest_rate}
                          >
                            <Input
                              readOnly
                            />
                          </Form.Item>
                      
                      </Col>
                      <Col>
                        <Form.Item
                            label="Minimum installment amount"
                            name='min_installment_amount'
                            initialValue={loanPreviewData.min_installment_amount}
                          >
                            <Input
                              readOnly
                            />
                          </Form.Item>
                      
                      </Col>
                      
                      </Row>
                      :
                      <></>
                    }
                     <Row className='p-3 my-3 border' style={{background: '#8888881d'}}>
                    <h5>Guarantors details (Atleast One)</h5>
                    <Row>
                 
                    <Col>
                    <Form.Item
                      label="Guarantor 1"
                      name="guatantor_name_1"
                      rules={[{ required: true, message: "Guarantor is required" }]}
                    >
                      <Input
                        onChange={(e)=> handleGuarantorChange(0, 'name', e.target.value)}
                        />
                    </Form.Item>
                
                    </Col>
                    <Col>
                    <Form.Item
                      label="Guarantor Phone"
                      name="guatantor_phone_1"
                      rules={[{ required: true, message: "Guarantor's phone number is required" }]}
                    >
                      <Input
                        onChange={(e) => handleGuarantorChange(0, 'phone', e.target.value)}
                        />
                    </Form.Item>
                    </Col>
                    <Col>
                    <Form.Item
                      label="Guarantor Address"
                      name="guatantor_address_1"
                      rules={[{ required: true, message: "Guarantor's address is required" }]}
                    >
                      <Input
                        onChange={(e)=> handleGuarantorChange(0, 'address', e.target.value)}
                        />
                    </Form.Item>
                    </Col>
                    </Row>
                    <Row>
                    </Row>
                    </Row>
                    <Row>
                    <Col>
                    <Button loading={submitting} type="primary" htmlType="submit" className='rounded-0 text-uppercase'>
                    <LuSave style={{marginRight: '5px'}} />

                      {

                        submitting ?
                      'Registering Loan...' :
                      'Register Loan'
                      }
                     </Button>
                     {
                      
                      <Button onClick={handlePrint} type='dashed' className='rounded-0 mx-3 text-uppercase small'>
                     <IoPrint style={{marginRight: '5px'}}/>
                     Print Form
                     </Button>}
                    </Col>
                     
                    </Row>
                  
                </Form>
            </Card>
        
        
        </Col>
        
        </Row>
    </Container>
  )
}

export default withAuth (NewLoanPage, ['admin', 'agent'])
